var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuestionDragdrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15V19H4V15H8ZM10 13H2V21H10V13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11.18H17V10C17 7.24 14.76 5 12 5C9.24 5 7 7.24 7 10V11.03H5V10C5 6.14 8.14 3 12 3C15.86 3 19 6.14 19 10V11.18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16H22V13H19V15H20V16Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18V19H19V21H22V18H20Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16V15H17V13H14V16H16Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18H14V21H17V19H16V18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionDragdrop);
export default __webpack_public_path__ + "static/media/icon-question-dragdrop.728113a91aabd7ae51c802679d5062aa.svg";
export { ForwardRef as ReactComponent };